import { BaseSearchParametersModel } from "../../../models/base-search-parameters.model";

import { SearchFiltersModel } from "./search-filters.model";

export class SearchParametersModel extends BaseSearchParametersModel {
    public templateId: string;
    public filters: SearchFiltersModel;

    public startDate: string;
    public endDate: string;

    public categories: Array<string> = [];
    public eventCategories: Array<string> = [];
    public needsOfChildren: Array<string> = [];
    public postcodes: Array<string> = [];
    public age: Array<string> = [];
    public frequency: Array<string> = [];
    public dietaryNeeds: Array<string> = [];
    public accessibility: Array<string> = [];
    public provisionTypes: Array<string> = [];
    public schoolNeeds: Array<string> = [];
    public specialDietCater: Array<string> = [];

    public postcode: string;
    public distance: string;
}
